"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class GatewaySoftwareVersion extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'gatewaySoftwareVersion';
        this._versionString = initParams.version_string;
        this._notes = initParams.notes;
        this._released = initParams.released;
        this._archived = initParams.archived;
        this._rejected = initParams.rejected;
        this._target = initParams.target;
        this._title = initParams.title;
    }
    set versionString(value) {
        console.error('Do not set objects this way');
    }
    setVersionString(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { version_string: value }, this);
    }
    get versionString() {
        return this._versionString;
    }
    set notes(value) {
        console.error('Do not set objects this way');
    }
    setNotes(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { notes: value }, this);
    }
    get notes() {
        return this._notes;
    }
    set released(value) {
        console.error('Do not set objects this way');
    }
    setReleased(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { released: value }, this);
    }
    get released() {
        return this._released;
    }
    set archived(value) {
        console.error('Do not set objects this way');
    }
    setArchived(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { archived: value }, this);
    }
    get archived() {
        return this._archived;
    }
    set rejected(value) {
        console.error('Do not set objects this way');
    }
    setRejected(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { rejected: value }, this);
    }
    get rejected() {
        return this._rejected;
    }
    set target(value) {
        console.error('Do not set objects this way');
    }
    setTarget(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { target: value }, this);
    }
    get target() {
        return this._target;
    }
    set title(value) {
        console.error('Do not set objects this way');
    }
    setTitle(value) {
        return this.dataService.updateGatewaySoftwareVersion(this.id, { title: value }, this);
    }
    get title() {
        return this._title;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateGatewaySoftwareVersion(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = GatewaySoftwareVersion;
//# sourceMappingURL=gatewaySoftwareVersion.js.map